import React from 'react';
import {useSelector} from '@xstate/react';
import {BrandButton} from '../../lib/brand-button/brand-button';
import useLabelTranslation from 'src/hooks/useLabelTranslation';
import {useBookingMachine} from '../../hooks/useBookingMachine';
import {selectSelectedTimeSlot} from '../../selectors/booking-selector';

import css from './booking-reschedule-form.css';


export const BookingRescheduleNextButton = () => {
  const {t} = useLabelTranslation();
  const {bookingActor} = useBookingMachine();
  const selectedTimeSlot = useSelector(bookingActor, selectSelectedTimeSlot);
  const handleRescheduleReasonFormSelect = () => {
    bookingActor.send({type: 'rescheduleReasonForm.go'});
  };

  return (
    <div className={css.rescheduleButtonSection}>
      <BrandButton
        isFluid
        actionType="submit"
        disabled={!selectedTimeSlot}
        onClick={handleRescheduleReasonFormSelect}
      >
        {t('Next', 'Next')}
      </BrandButton>
    </div>
  );
};
